<template>
  <div :class="wrapperClass" class="swiper mySwiper">
    <div class="swiper-wrapper">
      <slot name="default" />
    </div>

    <div
      v-show="autoplay || showArrows"
      :class="wrapperClass + '-btn-prev'"
      class="swiper-button-prev"
    >
      <v-btn
        class="rounded-lg px-1"
        color="rgba(0, 0, 0, .5)"
        depressed
        height="42"
        min-width="42"
        small
      >
        <v-icon color="white">mdi-chevron-right</v-icon>
      </v-btn>
    </div>
    <div
      v-show="autoplay || showArrows"
      :class="wrapperClass + '-btn-next'"
      class="swiper-button-next"
    >
      <v-btn
        class="rounded-lg px-1"
        color="rgba(0, 0, 0, .5)"
        depressed
        height="42"
        min-width="42"
        small
      >
        <v-icon color="white">mdi-chevron-left</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import { Autoplay, Navigation, Swiper } from "swiper";

let swiper = null;

export default {
  name: "swiperWrapper",

  props: {
    realIndex: Number,
    wrapperClass: String,
    loop: {
      type: Boolean,
      default: true,
    },
    autoplay: Boolean,
    swipeTo: Boolean,
    slidesPerView: {
      type: [Number, String],
      default: 1,
    },
    spaceBetween: {
      type: Number,
      default: 30,
    },
    showArrows: Boolean,
  },

  mounted() {
    let next = `.swiper-button-next.${this.wrapperClass + "-btn-next"}`;
    let prev = `.swiper-button-prev.${this.wrapperClass + "-btn-prev"}`;

    let that = this;

    this.$nextTick(() => {
      swiper = new Swiper(`.${this.wrapperClass || "swiper"}`, {
        // Optional parameters
        // @see https://swiperjs.com/swiper-api#parameters
        speed: 2000,
        slidesPerView: this.slidesPerView,
        loop: this.loop || false,
        spaceBetween: this.spaceBetween,
        autoplay: this.autoplay,
        // remove unused modules if needed
        modules: [Navigation, Autoplay],
        on: {
          slideChange(e) {
            if (!!that.realIndex) that.$emit("update:realIndex", e.realIndex);
          },
        },
        // Navigation arrows if needed
        navigation: {
          nextEl: next,
          prevEl: prev,
        },
      });
    });
  },

  methods: {
    getSwiper() {
      if (this.swipeTo) swiper.slideTo(swiper.clickedIndex, 300);
    },
  },
};
</script>

<style scoped>
.swiper-button-prev,
.swiper-button-next {
  width: fit-content;
}

.swiper-button-prev::after,
.swiper-button-next::after {
  content: none !important;
}
</style>
